import { ref, onMounted, computed } from 'vue';

export function useThemeScheme() {
  const currentScheme = ref(document.documentElement.getAttribute('scheme') || 'light');

  onMounted(() => {
    const observer = new MutationObserver(() => {
      currentScheme.value = document.documentElement.getAttribute('scheme') || 'light';
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['scheme'],
    });
  });

  const isDarkMode = computed(() => currentScheme.value === 'dark');

  return { currentScheme, isDarkMode };
}
